import React from 'react';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from './modules/components/Typography';
import withRoot from './modules/withRoot';


const CONTENT: string = `Welcome - financial statements & other Investor Relation: IR releated info will be updated here!
`;


function Koukoku() {
    return (
        <React.Fragment>
            <Container>
                <Box sx={{ mt: 7, mb: 12 }}>
                    <Typography variant="h3" gutterBottom marked="center" align="center">
                        広告
                    </Typography>
                </Box>
                <Box>
                    <Typography
                        color="inherit"
                        align="left"
                        variant="h5"
                        sx={{ mb: 10, mt: { sx: 5, sm: 5 } }}
                    >
                        {CONTENT.split('\n').map((line, index) => (
                            <React.Fragment key={index}>
                                {line}
                                <br />
                            </React.Fragment>
                        ))}
                    </Typography>
                </Box>
            </Container>
        </React.Fragment>
    );
}

export default withRoot(Koukoku);
